<template>
  <div class="scene">
    <!-- 背景模糊光斑 -->
    <div class="orb orb-1"></div>
    <div class="orb orb-2"></div>
    <div class="orb orb-3"></div>

    <!-- 主体内容 -->
    <div class="content">
      <span class="badge">✦ 欢迎来到我的小站 ✦</span>
      <h1 class="title">
        <span
          v-for="(char, index) in chars"
          :key="index"
          class="char"
          :style="{ animationDelay: `${index * 0.18 + 0.3}s` }"
        >{{ char }}</span>
      </h1>
      <p class="subtitle">Hello, World</p>
      <p class="desc">
        这是一段旅程的起点，用代码编织想法，把每一个灵感变成现实。<br>
        愿你在数字世界里，找到属于自己的星辰大海。
      </p>
      <div class="tags">
        <span class="tag" v-for="(tag, i) in tags" :key="i"
          :style="{ animationDelay: `${i * 0.15 + 1.6}s` }">
          {{ tag }}
        </span>
      </div>
      <p class="footer">Powered by Vue · Deployed on Cloudflare Pages</p>
    </div>
  </div>
</template>

<script>
export default {
  name: 'App',
  data() {
    return {
      chars: ['你', '好', '世', '界'],
      tags: ['🚀 持续探索', '💡 热爱创造', '🌊 保持好奇', '🎨 追求美感']
    }
  }
}
</script>

<style>
* {
  margin: 0;
  padding: 0;
  box-sizing: border-box;
}

html, body, #app {
  width: 100%;
  height: 100%;
  overflow: hidden;
}

.scene {
  width: 100%;
  height: 100%;
  display: flex;
  align-items: center;
  justify-content: center;
  background: linear-gradient(135deg, #0f0c29, #302b63, #24243e);
  position: relative;
}

/* 背景模糊光斑 */
.orb {
  position: absolute;
  border-radius: 50%;
  filter: blur(80px);
  opacity: 0.6;
  animation: float 8s ease-in-out infinite;
}

.orb-1 {
  width: 400px;
  height: 400px;
  background: #667eea;
  top: -100px;
  left: -100px;
  animation-delay: 0s;
}

.orb-2 {
  width: 350px;
  height: 350px;
  background: #f093fb;
  bottom: -80px;
  right: -60px;
  animation-delay: -3s;
}

.orb-3 {
  width: 280px;
  height: 280px;
  background: #4facfe;
  top: 50%;
  left: 60%;
  animation-delay: -5s;
}

@keyframes float {
  0%, 100% {
    transform: translate(0, 0) scale(1);
  }
  33% {
    transform: translate(30px, -30px) scale(1.05);
  }
  66% {
    transform: translate(-20px, 20px) scale(0.95);
  }
}

/* 主体内容 */
.content {
  text-align: center;
  position: relative;
  z-index: 1;
  padding: 60px 80px;
  border-radius: 24px;
  background: rgba(255, 255, 255, 0.05);
  backdrop-filter: blur(12px);
  -webkit-backdrop-filter: blur(12px);
  border: 1px solid rgba(255, 255, 255, 0.1);
  box-shadow: 0 25px 60px rgba(0, 0, 0, 0.3);
  animation: cardIn 1s ease-out both;
}

@keyframes cardIn {
  from {
    opacity: 0;
    transform: translateY(40px) scale(0.95);
  }
  to {
    opacity: 1;
    transform: translateY(0) scale(1);
  }
}

/* 大字标题 */
.title {
  font-size: clamp(4rem, 12vw, 8rem);
  font-weight: 900;
  letter-spacing: 0.08em;
  background: linear-gradient(to right, #a8edea, #fed6e3, #d299c2, #a8edea);
  background-size: 300% 100%;
  -webkit-background-clip: text;
  background-clip: text;
  -webkit-text-fill-color: transparent;
  animation: gradientShift 6s linear infinite;
}

@keyframes gradientShift {
  0% {
    background-position: 0% 50%;
  }
  100% {
    background-position: 300% 50%;
  }
}

/* 单字动效：从模糊到清晰 + 弹入 */
.char {
  display: inline-block;
  animation: charIn 0.9s cubic-bezier(0.22, 1, 0.36, 1) both;
}

.char:hover {
  animation: bounce 0.5s ease;
}

@keyframes charIn {
  0% {
    opacity: 0;
    filter: blur(20px);
    transform: translateY(50px) scale(1.6);
  }
  100% {
    opacity: 1;
    filter: blur(0);
    transform: translateY(0) scale(1);
  }
}

@keyframes bounce {
  0%, 100% {
    transform: translateY(0);
  }
  50% {
    transform: translateY(-16px);
  }
}

/* 顶部徽章 */
.badge {
  display: inline-block;
  font-size: 0.85rem;
  letter-spacing: 0.3em;
  color: rgba(255, 255, 255, 0.7);
  border: 1px solid rgba(255, 255, 255, 0.2);
  border-radius: 999px;
  padding: 8px 20px;
  margin-bottom: 28px;
  background: rgba(255, 255, 255, 0.06);
  animation: fadeUp 1s ease-out 0.1s both;
}

/* 副标题 */
.subtitle {
  margin-top: 24px;
  font-size: 1.3rem;
  font-weight: 300;
  letter-spacing: 0.5em;
  text-transform: uppercase;
  color: rgba(255, 255, 255, 0.6);
  animation: fadeUp 1s ease-out 1.2s both;
}

/* 描述文字 */
.desc {
  margin-top: 28px;
  font-size: 1.05rem;
  line-height: 2;
  color: rgba(255, 255, 255, 0.55);
  font-weight: 300;
  animation: fadeUp 1s ease-out 1.4s both;
}

/* 标签 */
.tags {
  margin-top: 32px;
  display: flex;
  gap: 14px;
  justify-content: center;
  flex-wrap: wrap;
}

.tag {
  font-size: 0.9rem;
  padding: 10px 22px;
  border-radius: 999px;
  color: rgba(255, 255, 255, 0.8);
  background: rgba(255, 255, 255, 0.07);
  border: 1px solid rgba(255, 255, 255, 0.12);
  backdrop-filter: blur(6px);
  transition: all 0.3s ease;
  animation: fadeUp 0.8s ease-out both;
  cursor: default;
}

.tag:hover {
  background: rgba(255, 255, 255, 0.15);
  border-color: rgba(255, 255, 255, 0.3);
  transform: translateY(-3px);
  box-shadow: 0 8px 24px rgba(0, 0, 0, 0.25);
}

/* 底部文字 */
.footer {
  margin-top: 36px;
  font-size: 0.8rem;
  letter-spacing: 0.15em;
  color: rgba(255, 255, 255, 0.3);
  animation: fadeUp 1s ease-out 2.2s both;
}

@keyframes fadeUp {
  from {
    opacity: 0;
    filter: blur(8px);
    transform: translateY(20px);
  }
  to {
    opacity: 1;
    filter: blur(0);
    transform: translateY(0);
  }
}
</style>
